import React from "react";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import IconButton from "@material-ui/core/IconButton";

import alderLogo from "../../../assets/img/alder-logo.png";
import styles from "./DownloadInventory.module.css";
import { Tooltip } from "@material-ui/core";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));
const DownloadInventory = (props) => {
  const classes = useStyles();
  console.log("Generate PDF Page");
  console.log("props");
  console.log(props);
  const InvoiceHtml = (props) => {
    console.log("Invoice Html");
    console.log(props);
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <img src={alderLogo} alt="alder logo" />
            <div className={styles.contentright}>
              <h3>Alder Furniture Pvt Ltd</h3>
              <h3>
                27 Furniture Block, Kirti Nagar, New Delhi – 110015, INDIA
              </h3>
              <h3>
                website: www.alder.in, Email: info@alder.in | sales@alder.in
              </h3>
              <h3>Phone: +91-011-42903322</h3>
            </div>
          </div>
          <div className={styles.alignStart}>
            <p>Warehouse Inventory</p>
          </div>

          <div className={styles.alignStart}>
            <p>Warehosue Detail</p>

            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th> Name</th>
                  <th> Bar Code</th>
                  <th> Address</th>
                  <th> Location</th>
                  <th>Contact Number</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{props.name.name}</td>
                  <td>{props.name.warehouse_barcode}</td>
                  <td>{props.name.address}</td>
                  <td>{props.name.warehouseLocation}</td>
                  <td>{props.name.contactNum}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.alignStart}>
            <p>Product Detail</p>

            <table className={styles.table} border="1">
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Product Name</th>
                  <th>Product Code</th>
                  <th>Category</th>
                  <th>Warehouse Stock</th>
                  <th>Booked Stock</th>
                  <th>Balance Stock</th>
                </tr>
              </thead>

              <tbody>
                {props.details.map((items, index) => {
                  return (
                    <tr>
                      {items.map((subItems, sIndex) => {
                        if(sIndex < 6) return <td>{subItems}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };
  const print = () => {
    const htmlString = renderToString(
      <InvoiceHtml details={props.details} name={props.name} />
    );

    const pdf = new jsPDF({
      orientation: "p",
      unit: "pt",
      format: "a3",
    });
    pdf.setTextColor(0, 0, 0);
    pdf.html(htmlString, {
      callback: function (pdf) {
        let filename = `product details.pdf`;
        pdf.save(filename);
      },
    });
  };
  return (
    <React.Fragment>
      <Tooltip title="Download Product details">
        <Button
          onClick={print}
          variant="contained"
          color="default"
          className={classes.button}
          startIcon={<GetAppRoundedIcon />}
        >
          Download Product details
        </Button>
      </Tooltip>
    </React.Fragment>
  );
};
export default DownloadInventory;
